import { z } from 'zod';
import { optionalText, text } from './common.js';
/**
 * The exact disclosure text the client showed, echoed back so the server can
 * confirm it still matches what it would show now (apps/api's
 * lib/sms-disclosures.ts builds it; the client never composes it). A
 * mismatch — the firm edited its text, staff changed the phone — is refused
 * rather than recorded, so the stored disclosure is always what was seen.
 * Sized for the built text plus the firm's own 1000-character addition.
 */
const smsConsentDisclosure = text(2000);
/**
 * A staff member recording a tenant's SMS consent decision. Never
 * NOT_ASKED from this route — that's only the default state before any
 * decision exists, not something staff explicitly set. `reason` is
 * required for both CONSENTED and DECLINED, not just DECLINED (unlike
 * setAchAccessSchema's revoke-only requirement) — every consent change
 * records who did it and why, per CLAUDE.md's SMS-consent decision.
 */
export const setSmsConsentSchema = z.object({
    status: z.enum(['CONSENTED', 'DECLINED']),
    reason: text(500),
    disclosure: smsConsentDisclosure,
});
/**
 * A tenant recording their own SMS consent decision from the portal popup.
 * `reason` is optional here, unlike the staff-facing schema above — a
 * staff member's reason documents a judgment call made on someone else's
 * behalf; a tenant clicking Yes/No on their own consent needs no
 * justification for their own decision. The service fills in a sensible
 * default when omitted.
 */
export const setOwnSmsConsentSchema = z.object({
    status: z.enum(['CONSENTED', 'DECLINED']),
    reason: optionalText(500),
    disclosure: smsConsentDisclosure,
});
//# sourceMappingURL=messaging.js.map